import React, { Component } from "react";
import { observer } from "mobx-react";
import { Carousel } from "../../../common";
import Review from "./Review";
import { ReviewsState } from "../../../../stores/ReviewsStore/Types";

interface Props {
  reviewsState: ReviewsState;
}

class ReviewsWrapper extends Component<Props, {}> {
  renderReviews = () => {
    const { reviewsState } = this.props;

    const scrollCarousel = (gridId, cardSelector, direction) => {
      const grid = document.getElementById(gridId);
      if (!grid) return;
      const card = grid.querySelector(cardSelector);
      if (!card) return;
      const scrollAmount = (card.offsetWidth + 20) * direction;
      grid.scrollBy({ left: scrollAmount, behavior: "smooth" });
    };

    const scrollTest = (direction: number) => {
      scrollCarousel("testGrid", ".test-card", direction);
    };

    switch (reviewsState.kind) {
      case "loading":
        return (
          <div className="ui active inverted dimmer">
            <div className="ui text loader">Loading</div>
          </div>
        );
      case "ready":
        return (
          <>
            <div className="header">
              <h2 className="section-title" id="testimonials-title">
                What People Are Saying
              </h2>
            </div>
            <div className="test-carousel">
              <button
                className="test-nav prev"
                onClick={() => scrollTest(-1)}
                aria-label="Previous testimonials"
              >
                ‹
              </button>
              <div className="test-grid" id="testGrid" role="list">
                {reviewsState.reviewsResource.reviews.map((review) => (
                  <Review key={review.id} review={review} />
                ))}
              </div>
              <button
                className="test-nav next"
                onClick={() => scrollTest(1)}
                aria-label="Next testimonials"
              >
                ›
              </button>
            </div>
          </>
        );

      default:
        return <div />;
    }
  };

  render() {
    return <div>{this.renderReviews()}</div>;
  }
}

export default observer(ReviewsWrapper);
